// @ts-ignore
export const options: Partial | (() => Partial) = null;


import {Directive, ElementRef, forwardRef, HostListener, Input} from '@angular/core';
import {AbstractControl, NG_VALIDATORS, Validator} from "@angular/forms";
import {ultrapassouValorMaximoTroco} from "../loja-pagamento/valor-troco";
import {emailPagamentoValido} from "../objeto/EmailPagamentoUtils";

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[emailPagamentoValido][ngModel]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: forwardRef(() => EmailPagamentoValidator), multi: true }
  ]
})
export class EmailPagamentoValidator implements Validator {
  constructor(private el: ElementRef) {
  }

  validate(c: AbstractControl): { [key: string]: any } {
    if(!c.value){
      this.el.nativeElement.setCustomValidity('');
      return null;
    }

    const valido = emailPagamentoValido(c.value);
    this.el.nativeElement.setCustomValidity(valido ? '' : 'email de pagamento inválido');

    return valido ? null : {emailPagamentoInvalido: true};
  }
}

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[logradouroValido][ngModel]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: LogradouroContatoValidator, multi: true }
  ]
})
// tslint:disable-next-line:directive-class-suffix
export class LogradouroContatoValidator  implements  Validator {
  @Input() sistema: string;

  constructor(private el: ElementRef) { }

  validate(c: AbstractControl): { [key: string]: any } {
    const logradouro = c.value;
    let erros: any;

    if(this.sistema === 'ecletica')
      if(logradouro && (logradouro.trim().split(' ').length < 2))
        erros = {"logradouroInvalido":  'Informe um endereço válido. '}


    if( erros ) {
      this.el.nativeElement.setCustomValidity('logradouro invalido');
    } else {
      this.el.nativeElement.setCustomValidity('');
    }

    return erros;
  }

}

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[trocoMinimo][ngModel]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: ValorTrocoPedido, multi: true }
  ]
})
// tslint:disable-next-line:directive-class-suffix
export class ValorTrocoPedido  implements  Validator {
  @Input() trocoMinimo: number;
  @Input() trocoMaximo: number;

  constructor(private el: ElementRef) {
  }

  validate(c: AbstractControl): { [key: string]: any } {
    const valor = c.value;
   // console.log('troco para: ' + valor)
    //console.log('troco minimo: ' + this.trocoMinimo)

    let erros: any = (!valor || Number(valor) < Number(this.trocoMinimo)) ? {"trocoMinimo": true} : null;

    if(!erros && this.trocoMaximo && ultrapassouValorMaximoTroco(valor, this.trocoMinimo, this.trocoMaximo))
      erros = {"trocoMaximo": true};

    if( erros ) {
      this.el.nativeElement.setCustomValidity('erro de troco');
    } else {
      this.el.nativeElement.setCustomValidity('');
    }

    return erros;
  }
}



@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[cpfValido][ngModel]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: forwardRef(() => CPFValidator), multi: true }
  ]
})
export class CPFValidator  implements  Validator {
  @Input("required") required: any;
  constructor() {   }
  validate(c: AbstractControl) {
    if (!this.required && !c.value)
      return null;

    let valido = this.cpfValido(c.value)
    if(valido) return null;

    return { cpfInvalido: true }
  }

  cpfValido(cpf){
    if(!cpf) return false;

    let numeros, digitos, soma, i, resultado, digitos_iguais;

    cpf = cpf.replace(/\D/g, "");

    digitos_iguais = 1;
    if (!cpf || cpf.length < 11)
      return false;
    for (i = 0; i < cpf.length - 1; i++)
      if (cpf.charAt(i) !== cpf.charAt(i + 1))
      {
        digitos_iguais = 0;
        break;
      }
    if (!digitos_iguais)
    {
      numeros = cpf.substring(0, 9);
      digitos = cpf.substring(9);
      soma = 0;
      for (i = 10; i > 1; i--)
        soma += numeros.charAt(10 - i) * i;
      resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
      if (resultado !== Number(digitos.charAt(0)))
        return false;
      numeros = cpf.substring(0, 10);
      soma = 0;
      for (i = 11; i > 1; i--)
        soma += numeros.charAt(11 - i) * i;
      resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
      if (resultado !== Number( digitos.charAt(1)))
        return false;
      return true;
    }
    else
      return false;
  }

}

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[cnpjValido][ngModel]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: forwardRef(() => CNPJValidador), multi: true }
  ]
})
export class CNPJValidador implements Validator {
  @Input("required") required: any;
  constructor() { }

  validate(c: AbstractControl) {
    if (!this.required && !c.value)
      return null;

    let valido = this.cnpjValido(c.value)
    if(valido) return null;

    return { cnpjInvalido: true }
  }

  cnpjValido(cnpj: string) {
    if (!cnpj) return false;

    cnpj = cnpj.replace(/\D/g, "");

    let digitos_iguais = 1, i, tamanho, numeros, digitos, soma, pos;

    if (cnpj.length < 14)
      return false;
    for (i = 0; i < cnpj.length - 1; i++)
      if (cnpj.charAt(i) !== cnpj.charAt(i + 1))
      {
        digitos_iguais = 0;
        break;
      }
    if (!digitos_iguais)
    {
      // Valida DVs
      tamanho = cnpj.length - 2
      numeros = cnpj.substring(0, tamanho);
      digitos = cnpj.substring(tamanho);
      soma = 0;
      pos = tamanho - 7;
      for (i = tamanho; i >= 1; i--) {
        soma += Number(numeros.charAt(tamanho - i)) * pos--;
        if (pos < 2)
          pos = 9;
      }
      let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
      if (resultado !== Number(digitos.charAt(0)))
        return false;

      tamanho = tamanho + 1;
      numeros = cnpj.substring(0, tamanho);
      soma = 0;
      pos = tamanho - 7;
      for (i = tamanho; i >= 1; i--) {
        soma += Number(numeros.charAt(tamanho - i)) * pos--;
        if (pos < 2)
          pos = 9;
      }
      resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
      if (resultado !==  Number(digitos.charAt(1)))
        return false;

      return true;

    } else {
      return false;
    }
  }
}
@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[nomeCompleto][ngModel]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: forwardRef(() => NomeConmpletoValidator), multi: true }
  ]
})
export class NomeConmpletoValidator  implements  Validator {
  // tslint:disable-next-line:no-input-rename
  @Input() validarNome: any = true;
  constructor() {
  }

  validate(c: AbstractControl): { [key: string]: any } {
    let valido = this.nomeValido(c.value)

    if(valido) return null;

    return { nomeCompleto: true }

  }

  nomeValido(nome: string){
    if( !this.validarNome) return true;

    const palavras = nome ? nome.trim().split(/\s+/) : [];

    if(!nome || palavras.length <= 1)
      return false;

    // Rejeita palavras abreviadas (ex: "J.", "M", "C.")
    for (const palavra of palavras) {
      if (  (palavra.endsWith('.') || palavra.length === 1))
        return false;
    }

    return true;
  }
}


@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[nomeValido][ngModel]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: forwardRef(() => NomeValidoValidator), multi: true }
  ]
})
export class NomeValidoValidator  implements  Validator {
  constructor() {
  }

  validate(c: AbstractControl): { [key: string]: any } {

    let valido = this.nomeValido(c.value)

    if(valido) return null;

    return { nomeValido: true }
  }

  nomeValido(nome){
    const possuiCaracteresInvalidos = (/[0-9@]/g.test(nome));

    return !possuiCaracteresInvalidos;
  }
}



@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[validadeCartao][ngModel]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: forwardRef(() => ValidadeCartaoValidator), multi: true }
  ]
})
export class ValidadeCartaoValidator implements Validator {
  constructor() {
  }

  validate(c: AbstractControl): { [key: string]: any } {
    if (!c.value) {
      return null; // Se não há valor, deixa a validação required cuidar disso
    }

    let valido = this.validadeValida(c.value);

    if (valido) return null;

    return { validadeExpirada: true };
  }

  validadeValida(dataValidade: Date): boolean {
    if (!dataValidade) return false;

    const hoje = new Date();
    const mesAtual = hoje.getMonth(); // 0-11
    const anoAtual = hoje.getFullYear();

    const mesValidade = dataValidade.getMonth(); // 0-11
    const anoValidade = dataValidade.getFullYear();

    // Se o ano da validade é maior que o atual, é válido
    if (anoValidade > anoAtual) {
      return true;
    }

    // Se o ano da validade é igual ao atual, verifica o mês
    if (anoValidade === anoAtual) {
      return mesValidade >= mesAtual;
    }

    // Se o ano da validade é menor que o atual, é inválido
    return false;
  }
}

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[tamanhoMax]'
})
export class MaxlengthDirective {
  @Input() tamanhoMax: number;
  constructor(private el: ElementRef) {  }

  @HostListener('input')
  onInput() {
    let value = this.el.nativeElement.value;
    if (value.length > this.tamanhoMax) {
      value = value.substr(0, this.tamanhoMax);
      this.el.nativeElement.value = value;
    }
  }
}
